<template>
    <div class="ah-page vendoer-edit-page">
        <div class="page-header" id="project-edit-page-header" style="margin-bottom: 25px">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!form.sno">新增客戶</h1>
                        <h1 v-if="form.sno">編輯客戶</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <el-form :model="form" ref="form" :rules="rules" label-position="right" label-width="200px" v-loading="isLoadingClient">
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">客戶資訊</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="fnam" label="客戶全名">
                            <el-input v-model="form.fnam" style="max-width: 500px" :maxlength="100" :show-word-limit="true" @change="handleFnamChange" @blur="onFnamBlur"></el-input>
                        </el-form-item>
                        <el-form-item prop="bsN_NO" label="統一編號" @change="handleBsnNoChange">
                            <div>
                                <el-radio v-model="form.bsN_NO" :label="1">有</el-radio>
                                <el-radio v-model="form.bsN_NO" :label="0">無</el-radio>
                            </div>
                        </el-form-item>
                        <el-form-item prop="bsn" v-if="form.bsN_NO == 1">
                            <el-input
                                v-model.trim="form.bsn"
                                v-if="form.bsN_NO == 1"
                                placeholder="請輸入統一編號"
                                style="max-width: 400px"
                                :minlength="8"
                                :maxlength="8"
                                :show-word-limit="true"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="adr" label="聯絡地址">
                            <el-input v-model="form.adr" style="max-width: 600px" :maxlength="500" :show-word-limit="true"> </el-input>
                        </el-form-item>
                        <el-form-item prop="bilL_DAY" label="結帳日">
                            <el-select v-model="form.bilL_DAY" placeholder="請選擇">
                                <el-option :key="0" label="無" :value="0"></el-option>
                                <el-option v-for="n in 31" :key="n" :label="n + '日'" :value="n"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="soO_DAY" label="付款日">
                            <el-select v-model="form.soO_DAY" placeholder="請選擇">
                                <el-option :key="0" label="無" :value="0"> </el-option>
                                <el-option v-for="n in 31" :key="n" :label="n + '日'" :value="n"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="accountLast5Number" label="匯款帳號後五碼">
                            <el-input v-model="form.accountLast5Number" style="max-width: 150px" :maxlength="5" :show-word-limit="true"> </el-input>
                        </el-form-item>
                        <el-form-item prop="note" label="備註">
                            <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="" v-model="form.note" :maxlength="200" :show-word-limit="true"> </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">聯絡窗口</div>
                    </div>
                    <div class="panel-body" style="margin-left: 220px">
                        <transition-group name="contact">
                            <el-card v-for="(contact, index) in form.vendorContacts" :key="contact.key" class="contact-card">
                                <div slot="header" class="clearfix">
                                    <span>聯絡窗口 {{ index + 1 }}</span>
                                    <el-button style="float: right; padding: 3px 0" type="text" @click.prevent="removeContact(contact)">刪除</el-button>
                                </div>
                                <el-form-item :prop="'vendorContacts.' + index + '.nam'" label="姓名" required>
                                    <el-input v-model="contact.nam" class="input-with-select" style="max-width: 400px" :maxlength="30" :show-word-limit="true">
                                        <el-select v-model="contact.gen" :prop="'contacts.' + index + '.gen'" slot="append" style="width: 100px">
                                            <el-option label="先生" :value="0"></el-option>
                                            <el-option label="小姐" :value="1"></el-option>
                                        </el-select>
                                    </el-input>
                                </el-form-item>
                                <el-form-item :prop="'vendorContacts.' + index + '.job'" label="職稱">
                                    <el-input v-model="contact.job" style="max-width: 400px" :maxlength="20" :show-word-limit="true"></el-input>
                                </el-form-item>
                                <el-form-item :prop="'vendorContacts.' + index + '.tel'" label="電話">
                                    <el-input v-model="contact.tel" style="max-width: 400px" :maxlength="20" :show-word-limit="true"></el-input>
                                </el-form-item>
                                <el-form-item :prop="'vendorContacts.' + index + '.ext'" label="分機">
                                    <el-input v-model="contact.ext" style="max-width: 150px" :maxlength="10" :show-word-limit="true"></el-input>
                                </el-form-item>
                                <el-form-item :prop="'vendorContacts.' + index + '.eml'" label="E-mail">
                                    <el-input v-model="contact.eml" style="max-width: 600px" :maxlength="100" :show-word-limit="true"></el-input>
                                </el-form-item>
                            </el-card>
                        </transition-group>
                        <div style="text-align: right">
                            <el-button @click="addContact" type="primary" size="small" plain>新增窗口</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <center>
                <el-button @click="onBack()">取消</el-button>
                <el-button type="primary" @click="onSubmit" :loading="isSubmitting" class="primary-action">送出</el-button>
            </center>
        </el-form>
    </div>
</template>
<script>
import { isGuiNumberValid } from 'taiwan-id-validator';

export default {
    name: 'VendorEditPage',
    components: {},
    data() {
        // 統一編號驗證
        const validateBsn = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入統一編號。'));
            } else if (!isGuiNumberValid(value, true)) {
                callback(new Error('統一編號格式不正確'));
            } else {
                callback();
            }
        };

        return {
            isLoadingClient: false,
            isSubmitting: false,
            topErrorMsg: null,
            form: {
                mno: 0, // 編號
                vdR_TYP: 'CL', // 類型（CL=客戶,VD=廠商,OS=外包）
                cnam: '', // 簡稱
                fnam: '', // 全名
                bsn: '', // 統編
                bsN_NO: 1, // 統編
                adr: '', // 地址
                onf: 1, // 啟用
                bilL_DAY: 0, // 結帳日
                soO_DAY: 0, // 收款日
                adr_CODE: '',
                ara: '',
                cty: '',
                voo: '',
                note: '',
                vendorContacts: [],
                accountLast5Number: '', // 匯款帳號後五碼
            },
            rules: {
                fnam: [{ required: true, message: '請輸入客戶全名', trigger: 'blur' }],
                bsn: [
                    { required: true, message: '請輸入統一編號', trigger: 'blur' },
                    { min: 8, message: '統一編號為8位數字', trigger: 'blur' },
                    { validator: validateBsn, trigger: 'blur' },
                ],
            },
            errorMsg: '',
        };
    },
    methods: {
        handleBsnNoChange() {
            this.form.bsn = '';
        },
        handleFnamChange() {
            this.form.cnam = this.form.fnam;
        },
        removeContact(item) {
            const index = this.form.vendorContacts.indexOf(item);
            if (index !== -1) {
                this.form.vendorContacts.splice(index, 1);
            }
        },
        addContact() {
            this.form.vendorContacts.push({
                key: Date.now(),
                nam: '',
                gen: 0,
                job: '',
                tel: '',
                ext: '',
                eml: '',
                dep: '',
            });
        },
        onSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.form.bsN_NO === 0) {
                        this.form.bsn = '';
                    }

                    this.form.fnam = this.form.fnam.trim();
                    this.form.cnam = this.form.fnam.trim();

                    this.$api({
                        url: 'VendorManagementPage/UpsertVendorDetail',
                        data: this.form,
                        method: 'POST',
                    }).then((resp) => {
                        console.log('vendor-added', resp);

                        this.onBack(resp.data.sno);
                    });
                } else {
                    this.scrollViewToError();
                }
            });
        },
        // 滑動到錯誤欄位
        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },
        reset() {
            this.form.fnam = '';
            this.form.cnam = '';
            this.form.bsn = '';
            this.form.adr = '';
            this.form.bilL_DAY = '';
            this.form.soO_DAY = '';
            this.form.vendorContacts = [];
            this.form.adr_CODE = '';
            this.form.ara = '';
            this.form.cty = '';
            this.form.voo = '';
            this.currStep = 1;
            this.addContact();
        },
        onBack(vendorsno) {
            if (this.$route.query.from) {
                this.$router.push({
                    name: this.$route.query.from,
                    query: { cache: 1, vendorsno },
                });
            } else this.$router.push({ name: 'vendor' });
        },
        applyContactsKey(vendorData) {
            for (let i = 0; i < vendorData.vendorContacts.length; i += 1) {
                // eslint-disable-next-line no-param-reassign
                vendorData.vendorContacts[i].key = i;
            }
            return vendorData;
        },
        onFnamBlur() {
            if (this.form.fnam) {
                this.form.fnam = this.form.fnam.trim();
            }
        },
    },
    mounted() {
        // 網址中含有序號，進入編輯模式，取得資料並載入
        const { sno } = this.$route.params;
        if (sno) {
            this.isLoadingClient = true;
            // api
            this.$api({ url: `VendorManagementPage/GetVendorInfo?sno=${sno}`, method: 'GET' }).then((resp) => {
                this.isLoadingClient = false;
                console.log(resp);
                // api 取得的聯絡人資料不含 key，需手動加上才能讓 v-for 正常運作
                this.form = this.applyContactsKey(resp.data.item);
            });
        } else {
            // 新增模式
            this.addContact();
        }
    },
    beforeDestory() {},
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.vendoer-edit-page {
    .contact-card {
        margin-bottom: 40px;
        border-radius: 15px;
    }

    // 新增聯絡窗口動畫
    .contact-item {
        display: inline-block;
        margin-right: 10px;
    }

    .contact-enter-active {
        transition: all 0.5s;
    }

    .contact-leave-active {
        transition: all 0.1s;
    }

    .contact-enter,
    .contact-leave-to {
        opacity: 0;
        transform: translateY(30px);
    }
}
</style>
